import React from 'react'

import { number, oneOf, string } from 'prop-types'

import highlightTranslation from 'Pods/Shared/Utils/highlightTranslation'

import roundHumanCount from 'Utils/roundHumanCount'

import { subscriptionPlanShape } from '../../../../../Utils/propTypes'
import translate from '../../../../../Utils/translatePlansRestructure'

const HIGHLIGHT_CLASS = 'subscription-purchase__benefits-highlight'
const ITEM_CLASS = 'subscription-purchase__benefits-item subscription-purchase__benefits-item--restructure'

const highlight = (key, highlights) => highlightTranslation(translate, key, highlights, HIGHLIGHT_CLASS)

function PlanDetails({
  plan, band = 'essentials', downloadsPerMonth, pricePerModel, fromLabel, perModelLabel,
}) {
  const isUpgrade = Boolean(plan.isUpgrade)

  const allowance = {
    key: 'allowance',
    content: highlight('bullets.allowance', {
      downloads: translate('bullets.downloads', { value: downloadsPerMonth }),
      generations: translate('bullets.generations', { value: plan.generationsPerMonth }),
    }),
  }

  const benefits = isUpgrade ? [
    {
      key: 'catalog',
      content: highlight('bullets.catalog.premium_upgrade', { value: roundHumanCount(plan.catalogValue) }),
    },
    allowance,
  ] : [
    allowance,
    { key: 'catalog', content: highlight(`bullets.catalog.${band}`, { value: roundHumanCount(plan.catalogValue) }) },
    { key: 'license', content: translate('bullets.license') },
    {
      key: 'annual',
      content: highlight('bullets.pay_annually', {
        months: translate('bullets.months_free', { value: plan.annualFreeMonths }),
      }),
    },
  ]

  return (
    <>
      <div className="subscription-purchase__option-header subscription-purchase__option-header--restructure">
        <span className="subscription-purchase__plan-title subscription-purchase__option-title">
          {translate(`plan_names.${band}`)}
        </span>
        <div className="subscription-purchase__option-price subscription-purchase__option-price--restructure">
          <div className="subscription-purchase__option-price-row">
            <span className="cgt-caption-semibold subscription-purchase__from-prefix">{fromLabel}</span>
            <span className="subscription-purchase__plan-price cgt-heading-300">{pricePerModel}</span>
          </div>
          <span className="cgt-caption subscription-purchase__per-model-label">{`/${perModelLabel}`}</span>
        </div>
      </div>
      <ul className="subscription-purchase__benefits-list subscription-purchase__benefits-list--restructure">
        {benefits.map(({ key, content }) => (
          <li key={key} className={ITEM_CLASS}>{content}</li>
        ))}
      </ul>
    </>
  )
}

PlanDetails.propTypes = {
  plan: subscriptionPlanShape.isRequired,
  band: oneOf(['essentials', 'premium']),
  downloadsPerMonth: number.isRequired,
  pricePerModel: string.isRequired,
  fromLabel: string.isRequired,
  perModelLabel: string.isRequired,
}

export default PlanDetails
